var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4218_33813)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2994 12.0709C3.4085 9.77972 4.36766 7.61149 5.98959 5.98957C7.61151 4.36764 9.77975 3.40848 12.0709 3.29938C14.3621 3.19028 16.6116 3.93907 18.3803 5.39953C18.4889 5.48923 18.5547 5.62059 18.5614 5.7613C18.5681 5.90201 18.5151 6.03902 18.4155 6.13864L12.6306 11.9235L18.0104 17.3033C18.2057 17.4985 18.2057 17.8151 18.0104 18.0104C17.8151 18.2056 17.4986 18.2056 17.3033 18.0104L11.9235 12.6306L6.13866 18.4155C6.03904 18.5151 5.90203 18.5681 5.76132 18.5614C5.62061 18.5547 5.48925 18.4889 5.39955 18.3803C3.93909 16.6116 3.1903 14.362 3.2994 12.0709ZM17.3063 5.8336C15.8043 4.75426 13.9767 4.20976 12.1185 4.29825C10.0758 4.39552 8.14272 5.25065 6.6967 6.69667C5.25067 8.1427 4.39554 10.0758 4.29827 12.1184C4.20978 13.9767 4.75428 15.8043 5.83362 17.3063L17.3063 5.8336Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 18.511C3.5 18.2348 3.72386 18.011 4 18.011L20 18.011C20.2761 18.011 20.5 18.2348 20.5 18.511C20.5 18.7871 20.2761 19.011 20 19.011L4 19.011C3.72386 19.011 3.5 18.7871 3.5 18.511Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4218_33813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.f655dfe3f4745cbac54b8213610a50f3.svg";
export { ForwardRef as ReactComponent };